// src/config/appVersion.js — current native app (APK) version
// Bump this whenever a new APK is built & deployed, and update /app/latest.json on the server.
export const CURRENT_APP_VERSION = '1.0.0';
